export default __webpack_public_path__ + "static/illistration2-125d6b8d4e72eb8f9b69efa76e07acdb.png";